import { Component, inject, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CommonComponent } from '@components/common.component';
import moment from 'moment/moment';
import { combineLatest, filter, takeUntil, tap } from 'rxjs';
import { Database, onValue, ref } from '@angular/fire/database';
import { UserMessage } from '@models/messages/user-message.model';
import { JsonPipe, KeyValue, KeyValuePipe, NgForOf, NgIf, SlicePipe } from '@angular/common';
import { AvatarDirective } from '@directives/avatar.directive';
import { getDocumentPaths } from '@functions/helper.functions';

@Component({
  selector: 'app-messages-dashboard',
  standalone: true,
  imports: [RouterLink, KeyValuePipe, NgForOf, NgIf, JsonPipe, SlicePipe, AvatarDirective],
  templateUrl: './messages-dashboard.component.html',
  styles: ``,
})
export class MessagesDashboardComponent extends CommonComponent implements OnInit {
  mm = moment;
  database = inject(Database);
  inbox: Record<string, UserMessage> | null = null;

  ngOnInit(): void {
    const paths = getDocumentPaths(this.user, this.community, this.resident ?? undefined);
    combineLatest([this.community$, this.user$])
      .pipe(
        filter(([community, user]) => !!community && !!user),
        tap(() => {
          const userPath = paths.userPath;
          const userRef = ref(this.database, userPath);

          onValue(
            userRef,
            (snapshot) => {
              this.inbox = snapshot.val();
            },
            { onlyOnce: false },
          );
        }),
        takeUntil(this.destroy$),
      )
      .subscribe();
  }

  onConversation(keyValue: KeyValue<string, UserMessage>) {
    const path = this.role === 'COMMUNITY_RELATIVE' ? '/family' : '/';
    this.router.navigate([path, 'messages'], { queryParams: { key: keyValue.key } }).then();
  }
}
